export class AgentServicePhoto {
}
//# sourceMappingURL=agent-service-photo.js.map